import { render, staticRenderFns } from "./rankList.vue?vue&type=template&id=47a3cb35&scoped=true&"
import script from "./rankList.vue?vue&type=script&lang=js&"
export * from "./rankList.vue?vue&type=script&lang=js&"
import style0 from "./rankList.vue?vue&type=style&index=0&id=47a3cb35&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3cb35",
  null
  
)

export default component.exports